angular.module('fg').directive('fgFieldImage', function () {
  return {
    replace: true,
    templateUrl: 'angular-form-gen/field-templates/default/image.ng.html'
  };
});
